/**
 * Timestamp ordering helpers for the breakdown flow.
 *
 * Both operands are `YYYY-MM-DDTHH:mm` strings produced by `combineDateTime`.
 * The format is lexicographically ordered, so string `<` / `>=` compare
 * chronologically without parsing.
 *
 * Empty operands short-circuit to `true` — an empty field is the "please fill
 * me" case, gated separately by the leaf's empty-field validator. Ordering
 * predicates should never turn an empty field into an ordering violation.
 */

/**
 * @param {string} a
 * @param {string} b
 * @returns {boolean} `true` when `a >= b`, or when either operand is empty.
 */
export const isAtOrAfter = (a, b) => {
	if (!a || !b) return true;
	return a >= b;
};

/**
 * @param {string} a
 * @param {string} b
 * @returns {boolean} `true` when `a < b`, or when either operand is empty.
 */
export const isStrictlyBefore = (a, b) => {
	if (!a || !b) return true;
	return a < b;
};
